import { PaymentFrequencyEnum, PaymentPlanType } from 'V2/Types/Payment';

export const isInstallmentPlan = (paymentPlan: PaymentPlanType) =>
  paymentPlan.paymentFrequencyIdentifier === 'monthly' ||
  paymentPlan.paymentFrequencyIdentifier === 'semi_monthly' ||
  paymentPlan.paymentFrequencyIdentifier === 'bi_weekly' ||
  paymentPlan.paymentFrequencyIdentifier === 'weekly';

export const isPayInFullPlan = (paymentPlan: PaymentPlanType) =>
  paymentPlan.paymentFrequencyIdentifier === 'full_pay' ||
  paymentPlan.paymentFrequencyIdentifier === 'in_full';

export const formatFrequencyLabel = (
  identifier: PaymentFrequencyEnum,
  frequencyLabel: string
) => {
  if (identifier === 'bi_weekly') {
    return `every ${frequencyLabel.toLowerCase()}`;
  }

  return frequencyLabel;
};
